import {isNonBlankString} from '../responseRefiners'

type Password = string & {brand: 'Password'}

const PASSWORD_MINIMUM_LENGTH = 8
const PASSWORD_MAXIMUM_LENGTH = 32
const PASSWORD_MAXIMUM_BYTE_LENGTH = 72

/**
 * Parse a valid NFC normalized password string from an unknown candidate.
 *
 * @see {@link isValid}.
 * @param candidate The candidate password to parse.
 */
function parse(candidate: unknown): Password {
  if (!isNonBlankString(candidate)) {
    throw new Error('Password may not be blank, empty, null or undefined')
  }

  const normalizedPassword = candidate.normalize('NFC')

  if (!isValid(normalizedPassword)) {
    throw new Error(
      `Expected a password between ${PASSWORD_MINIMUM_LENGTH} and ${PASSWORD_MAXIMUM_LENGTH} characters and less than ${PASSWORD_MAXIMUM_BYTE_LENGTH} bytes in length but was ${
        candidate.length
      } characters and ${new Blob([candidate]).size} bytes`
    )
  }

  return candidate as Password
}

/**
 * Determine if the provided candidate string is a valid password string. i.e.
 *
 * >= {@link PASSWORD_MINIMUM_LENGTH}
 * <= {@link PASSWORD_MAXIMUM_LENGTH}
 * < {@link PASSWORD_MAXIMUM_BYTE_LENGTH} bytes
 *
 * @param candidate The candidate password string to evaluate validity of.
 */
function isValid(candidate: string) {
  return (
    isNonBlankString(candidate) &&
    candidate.length >= PASSWORD_MINIMUM_LENGTH &&
    candidate.length <= PASSWORD_MAXIMUM_LENGTH &&
    new Blob([candidate]).size < PASSWORD_MAXIMUM_BYTE_LENGTH
  )
}

const Password = {parse, isValid}
export default Password
